var map = {
	"./belpasso_logo.png": 383,
	"./bg.png": 384,
	"./bg_footer.png": 385,
	"./bg_white.png": 386,
	"./bg_white_left.png": 387,
	"./bg_white_modified.png": 388,
	"./bg_white_right.png": 389,
	"./icons_box/folder.png": 108,
	"./icons_box/folder_color.png": 390,
	"./icons_box/handshake.png": 110,
	"./icons_box/handshake_color.png": 391,
	"./icons_box/lightbulb.png": 107,
	"./icons_box/lightbulb_color.png": 392,
	"./icons_box/project.png": 109,
	"./icons_box/project_color.png": 393,
	"./italy.png": 394,
	"./logo-cardillo.png": 65,
	"./logo-comune-belpasso.png": 59,
	"./logo-comune-biancavilla.png": 62,
	"./logo-comune-bronte.png": 60,
	"./logo-comune-messina.png": 63,
	"./logo-comune-paterno.png": 61,
	"./logo-terna-spa.png": 64,
	"./logo.png": 37,
	"./usa.png": 395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 382;